import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=6613d74e&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=6613d74e&prod&scoped=true&lang=css"
import style1 from "./Email.vue?vue&type=style&index=1&id=6613d74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613d74e",
  null
  
)

export default component.exports